import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EmojiPlaceholder } from '../src/EmojiPlaceholder.tsx';
import type { EmojiComponentProps } from '../src/__types__/EmojiComponent.ts';

export const LazyEmojiComponentLoader: LoadableType<EmojiComponentProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-srcEmojiComponent" */ '../src/EmojiComponent.tsx'))
			.EmojiComponent,
	loading: (props) => (props.emoji ? <EmojiPlaceholder {...props} /> : null),
});
